import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/services/language.service';


@Component({
  selector: 'app-welcome-gift',
  templateUrl: './welcome-gift.component.html',
  styleUrls: ['./welcome-gift.component.css']
})
export class WelcomeGiftComponent implements OnInit {
  selectedLanguage: string;
  constructor(private dialogRef: MatDialogRef<HeaderComponent>,
    private translateService: TranslateService,
    private languageService: LanguageService
  ) {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.selectedLanguage = language;
    });
  }

  ngOnInit() {
    setTimeout(() => {
      this.dialogRef.close()
    }, 3000)
    
    this.switchLanguage(this.selectedLanguage);
  }

  switchLanguage(languageCode: string): void {
    this.translateService.use(languageCode);
  }
}
